import { useMappedState } from "redux-react-hook";
import * as React from "react";
import * as _ from "lodash";

import type { IStore } from "src/core/shared/store";
import { PermissionCodeType } from "src/core/shared/api/roles.api";
import { useDrop } from "src/core/drops/hooks";
import { CustomerDropStatuses } from "src/core/customers/api/customers.api";

/**
 * Hook to provide check user permission functionality
 *
 * @returns
 */
const useCheckUserPermission = () => {
  const { currentRole } = useMappedState(({ global }: IStore) => ({ currentRole: global.role }));
  const [ { drop } ] = useDrop();

  /** Checks a permission code against a user */
  const checkUserPermission = React.useCallback((permission: PermissionCodeType): boolean => {
    if (!currentRole?.permissions) {
      return false;
    }

    // For customers we also check their current delivery point to determine the permissions
    if (currentRole.type === "customer") {
      if (!drop) {
        return false;
      }

      // if the delivery point or customer is deactivated/suspended
      // give view only access
      if ([
        CustomerDropStatuses.Suspended,
        CustomerDropStatuses.Deactivated,
        CustomerDropStatuses.OverCreditLimit
      ].includes(drop?.status)) {
        if (permission.includes("view")) {
          return true;
        } else {
          return false;
        }
      }
    }

    return !!_.find(currentRole.permissions, userPermission => userPermission.code === permission);
  }, [ currentRole, drop ]);

  return checkUserPermission;
};

export default useCheckUserPermission;
